/** Bitget USDT-SWAP — 심볼 검색 팝업 상단 고정 */
export const PINNED_BITGET_SYMBOL_BASES = ['BTC', 'ETH', 'XRP', 'SOL', 'ETC', 'BCH'];

export const PINNED_BITGET_SYMBOLS = PINNED_BITGET_SYMBOL_BASES.map(
  (base) => `${base}/USDT:USDT`
);

export function sortSymbolsWithPinned(symbols, searchTerm = '') {
  const list = Array.isArray(symbols) ? symbols : [];
  const query = String(searchTerm || '').trim().toLowerCase();

  const matched = query
    ? list.filter((s) => String(s).toLowerCase().includes(query))
    : [...list];

  const pinned = PINNED_BITGET_SYMBOLS.filter((s) => matched.includes(s));
  const pinnedSet = new Set(pinned);
  const rest = matched
    .filter((s) => !pinnedSet.has(s))
    .sort((a, b) => String(a).localeCompare(String(b)));

  return [...pinned, ...rest];
}
